module.exports = __webpack_public_path__ + "static/media/media-owner-benefit-flat-4-1.762e697d.svg";